module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-main"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": "out-in"
    }
  }, [(_vm.menu) ? [_c('lxm-menu')] : (_vm.nav) ? [_c('lxm-nav', {
    attrs: {
      "title": _vm.navTitle,
      "share": _vm.nav.share,
      "menu": !_vm.nav.share
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lxm-transition-fade",
      "mode": "out-in"
    }
  }, [(_vm.bottomBar) ? [(_vm.bottomBar.type === 'bottom-tabs') ? [_c('lxm-bottom-tabs')] : (_vm.bottomBar.type === 'close-notification') ? [_c('lxm-close-notification', {
    attrs: {
      "highlight": _vm.bottomBar.highlight,
      "open": _vm.notification.open,
      "loading": _vm.notification.loading
    },
    on: {
      "click": _vm.closeNotificationClicked
    }
  })] : (_vm.bottomBar.type === 'prev-next') ? [_c('lxm-prev-next')] : (_vm.bottomBar.type === 'contact-bottom-bar') ? [_c('lxm-contact-bottom-bar', {
    attrs: {
      "phone": _vm.contact.phone,
      "address": _vm.contact.address
    }
  })] : _vm._e()] : _vm._e()], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e5f0ce84", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e5f0ce84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/index.vue
// module id = 892
// module chunks = 0